import classNames from 'classnames'
import { Override } from 'maeng-type/Common'
import { ComponentProps, ReactNode, forwardRef, useMemo } from 'react'

export type LinkProps = Override<
  ComponentProps<'a'>,
  {
    color?:
      | 'neutral'
      | 'primary'
      | 'secondary'
      | 'accent'
      | 'info'
      | 'success'
      | 'warning'
      | 'error'
    children?: ReactNode
    hover?: boolean
  }
>

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, hover, className: classProps = '', ...props }, ref) => {
    const className = useMemo(
      () =>
        classNames({
          link: true,
          'link-neutral': props.color === 'neutral',
          'link-primary': props.color === 'primary',
          'link-secondary': props.color === 'secondary',
          'link-accent': props.color === 'accent',
          'link-info': props.color === 'info',
          'link-success': props.color === 'success',
          'link-warning': props.color === 'warning',
          'link-error': props.color === 'error',
          'link-hover': hover,
          [classProps]: true,
        }),
      [classProps, hover, props.color],
    )
    return (
      <a ref={ref} className={className} {...props}>
        {children}
      </a>
    )
  },
)

export default Link
